import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Api from 'services/api'
import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import { ButtonContainer, SinglePanePage, PageTitle } from 'styles/shared'

import Brand from 'helpers/brand'
import Spinner from 'components/Spinner'
import blobToFileDownload from 'helpers/blobToFileDownload'

import usePaywallStatements from 'hooks/usePaywallStatements'
import Table from 'components/Table'

const PaywallStatements = () => {
  const { dealerId } = useParams()
  const { statements, areStatementsLoaded } = usePaywallStatements(dealerId)
  const navigate = useNavigate()

  if (!areStatementsLoaded) {
    return <Spinner variant="page" />
  }

  const onClickStatement = (statement) => {
    if (!dealerId) return
    Api.Paywall.getInvoice(dealerId, statement.accountNo, statement.invoiceNo)
      .then(res => {
        if (res.content) {
          const blob = new Blob([res.content], { type: 'text/html' })
          blobToFileDownload(blob, `diagnostics-premium ${statement.invoiceNo}`)
        }
      })
  }

  return (
    <>
      <S.Top>
        <S.ProductLogo src={Brand.premiumProductLogoPath()} alt={`${Brand.brandName()} logo`} />
        <div />
      </S.Top>
      <SinglePanePage>
        <S.PageTitle>Statements</S.PageTitle>
        <S.Form>
          <Table
            items={statements}
            noDataMessage={{
              title: 'No Statements',
              description: 'Statements will show up here.'
            }}
          >
            <S.Header>
              <S.HeaderCell title="Invoice Date" />
              <S.HeaderCell title="Invoice Number" />
            </S.Header>

            {statements.map(statement => (
              <S.Row key={statement.invoiceNo}>
                <S.Cell>{statement.invoiceDate}</S.Cell>
                <S.Cell>
                  <Button decoration="link" text={String(statement.invoiceNo)} onPress={() => { onClickStatement(statement) }} />
                </S.Cell>
              </S.Row>
            ))}
          </Table>
        </S.Form>
        <S.ButtonContainer>
          <Button decoration="positive" text="Close" onPress={() => navigate(-1)} />
        </S.ButtonContainer>
      </SinglePanePage>
    </>
  )
}

const S = {
  ButtonContainer: styled(ButtonContainer)`
    border-top: none;
    max-width: 800px;
    margin-top: 0px;
  `,
  Header: styled(Table.Header)`
    background-color: #E9EFF1;
    border-radius: 10px;
  `,
  HeaderCell: styled(Table.HeaderCell)`
    background-color: #E9EFF1;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  `,
  Cell: styled(Table.Cell)`
    width: 50%;
    max-width: 400px;
    padding-left: 20px;
  `,
  PageTitle: styled(PageTitle)`
    margin-top: 10px;
    text-transform: none;
  `,
  Form: styled.form`
    max-width: 800px;
  `,
  ProductLogo: styled.img`
    height: 50px;
  `,
  Top: styled.div`
    display: flex;
    padding-top: 10px;
    padding-left: 20px;
  `,
  Row: styled(Table.Row)`
    border-bottom: 1px solid #E9EFF1;
    padding: 3px 0;
    align-items: center;
    background-color: #F3F7F8;
    &:last-child {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }
  `
}

export default PaywallStatements
